import { createSlice } from '@reduxjs/toolkit';
import { resetAccountPassword, signInApi, verifyToken } from '../api/authentication';

interface UsersState {
  loading: boolean;
  currentRequestId: undefined | string;
  token: string;
  userData: any;
  location: any;
  userName: any;
  error: any;
}

const initialState = {
  loading: false,
  currentRequestId: undefined,
  token: '',
  userData: null,
  location: null,
  error: null,
} as UsersState;

export const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    localAuth: (state, action) => {
      state.userData = action.payload;
    },
    resetAuth: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase("RESET_ALL", (state, action) => {
        return initialState;
      })
      .addCase(signInApi.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
        state.error = null;
      })
      .addCase(signInApi.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.currentRequestId = undefined;
          state.loading = false;
          state.token = action.payload?.data?.authorizationToken;
          state.userData = action.payload?.data?.party;
          state.location = action.payload?.data?.location;
          state.userName = action.payload?.data?.userName;
          state.error = null; 
        }
      })
      .addCase(signInApi.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.loading = false;
          state.currentRequestId = undefined;
          state.error = action.error?.message || 'Login failed';
        }
      })
      .addCase(verifyToken.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(verifyToken.fulfilled, (state, action) => {
        if (state.loading) {
          state.loading = false;
        }
      })
      .addCase(verifyToken.rejected, (state, action) => {
        if (state.loading) {
          state.loading = false;
        }
      })
      .addCase(resetAccountPassword.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(resetAccountPassword.fulfilled, (state, action) => {
        if (state.loading) {
          state.loading = false;
        }
      })
      .addCase(resetAccountPassword.rejected, (state, action) => {
        if (state.loading) {
          state.loading = false;
        }
      });
  },
});

export const { localAuth, resetAuth } = authenticationSlice.actions;

export default authenticationSlice.reducer;